<template>
  <transition
    :css="false"
    @enter="enter"
    @leave="leave"
  >
    <slot />
  </transition>
</template>

<script>
import { TimelineLite, TweenLite, Power4, Back } from 'gsap'

export default {
  methods: {
    enter(el, done) {
      const timeline = new TimelineLite({ onComplete: done })
      const childEl = el.childNodes[0]

      timeline.fromTo(
        el,
        0.5,
        {
          height: '0',
          overflow: 'hidden',
        },
        {
          height: '100vh',
          overflow: 'hidden',
          ease: Power4.easeOut,
          onComplete: () => {
            TweenLite.set(
              el,
              { overflow: 'auto' },
            )
          },
        },
      ).fromTo(
        childEl,
        0.5,
        {
          alpha: 0,
          xPercent: -10,
        },
        {
          alpha: 1,
          xPercent: 0,
          delay: -0.4,
          ease: Back.easeOut,
        },
      )
    },
    leave(el, done) {
      TweenLite.set(
        el,
        { overflow: 'hidden' },
      )
      TweenLite.to(
        el,
        0.3,
        {
          height: 0,
          ease: Power4.easeOut,
          onComplete: done,
        },
      )
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/TransitionMenu.vue